import { EMasterFiltersActionTypes } from '../../actions/masterFilters';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function masterFiltersReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EMasterFiltersActionTypes.SetActiveTab:
      return {
        ...state,
        masterFilters: {
          ...state.masterFilters,
          activeTab: action.payload.value,
        },
      };

    case EMasterFiltersActionTypes.SelectSubAgent:
      return {
        ...state,
        masterFilters: {
          ...state.masterFilters,
          selectedSubAgentId: action.payload.subAgentId,
        },
      };

    case EMasterFiltersActionTypes.UnselectSubAgent:
      return {
        ...state,
        masterFilters: {
          ...state.masterFilters,
          selectedSubAgentId: undefined,
        },
      };

    default:
      return state;
  }
}
